// MolarMassCalculator.js
import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "Kalkulator Massa Molar - Pelajari Cara Menghitung Massa Molar dengan Mudah";
const DESCRIPTION =
  "Kalkulator massa molar canggih: hitung massa senyawa kimia apa pun (dalam gram/mol) secara akurat! Masukkan rumus molekul (misalnya H₂SO₄) untuk mengetahui massa molar dengan penjelasan langkah perhitungan yang rinci - alat penting untuk siswa kimia dan peneliti.";
const KEYWORDS = "hitung massa molar, kalkulator massa molar";
const OG_URL = "https://do-calculate.com/calculator/id/molar-mass-calculator/";
const elements = [
  { symbol: "Ac", name: "Aktinium", molarMass: 227 },
  { symbol: "Ag", name: "Perak", molarMass: 107.8682 },
  { symbol: "Al", name: "Aluminium", molarMass: 26.9815 },
  { symbol: "Am", name: "Amerisium", molarMass: 243 },
  { symbol: "Ar", name: "Argon", molarMass: 39.948 },
  { symbol: "As", name: "Arsenik", molarMass: 74.9216 },
  { symbol: "At", name: "Astatin", molarMass: 210 },
  { symbol: "Au", name: "Emas", molarMass: 196.9665 },
  { symbol: "Ba", name: "Barium", molarMass: 137.327 },
  { symbol: "Bk", name: "Berkelium", molarMass: 247 },
  { symbol: "Be", name: "Berilium", molarMass: 9.0122 },
  { symbol: "Bi", name: "Bismut", molarMass: 208.98 },
  { symbol: "Bo", name: "Boron", molarMass: 10.81 },
  { symbol: "Br", name: "Bromin", molarMass: 79.904 },
  { symbol: "Bs", name: "Bohrium", molarMass: 270 },
  { symbol: "C", name: "Karbon", molarMass: 12.011 },
  { symbol: "Ca", name: "Kalsium", molarMass: 40.078 },
  { symbol: "Cd", name: "Kadmium", molarMass: 112.414 },
  { symbol: "Ce", name: "Serium", molarMass: 140.116 },
  { symbol: "Cf", name: "Kalifornium", molarMass: 251 },
  { symbol: "Cl", name: "Klorin", molarMass: 35.45 },
  { symbol: "Cm", name: "Curium", molarMass: 247 },
  { symbol: "Cn", name: "Kopernisium", molarMass: 285 },
  { symbol: "Co", name: "Kobalt", molarMass: 58.933 },
  { symbol: "Cr", name: "Kromium", molarMass: 51.996 },
  { symbol: "Cs", name: "Sesium", molarMass: 132.905 },
  { symbol: "Cu", name: "Tembaga", molarMass: 63.546 },
  { symbol: "Db", name: "Dubnium", molarMass: 268 },
  { symbol: "Ds", name: "Darmstadtium", molarMass: 281 },
  { symbol: "Dy", name: "Disprosium", molarMass: 162.5 },
  { symbol: "Er", name: "Erbium", molarMass: 167.259 },
  { symbol: "Es", name: "Einsteinium", molarMass: 252 },
  { symbol: "Eu", name: "Europium", molarMass: 151.964 },
  { symbol: "Fm", name: "Fermium", molarMass: 257 },
  { symbol: "Fl", name: "Flerovium", molarMass: 289 },
  { symbol: "Fm", name: "Fermium", molarMass: 257 },
  { symbol: "Fr", name: "Fransium", molarMass: 223 },
  { symbol: "Ga", name: "Galium", molarMass: 69.723 },
  { symbol: "Gb", name: "Gadolinium", molarMass: 157.25 },
  { symbol: "Ge", name: "Germanium", molarMass: 72.63 },
  { symbol: "H", name: "Hidrogen", molarMass: 1.0079 },
  { symbol: "He", name: "Helium", molarMass: 4.0026 },
  { symbol: "Ho", name: "Holmium", molarMass: 164.93 },
  { symbol: "Hs", name: "Hasium", molarMass: 277 },
  { symbol: "I", name: "Iodin", molarMass: 126.904 },
  { symbol: "Ir", name: "Iridium", molarMass: 192.217 },
  { symbol: "K", name: "Kalium", molarMass: 39.098 },
  { symbol: "Kr", name: "Kripton", molarMass: 83.798 },
  { symbol: "La", name: "Lantanum", molarMass: 138.905 },
  { symbol: "Li", name: "Litium", molarMass: 6.94 },
  { symbol: "Lr", name: "Lawrensium", molarMass: 262 },
  { symbol: "Lu", name: "Lutetium", molarMass: 174.966 },
  { symbol: "Md", name: "Mendelevium", molarMass: 258 },
  { symbol: "Mg", name: "Magnesium", molarMass: 24.305 },
  { symbol: "Mn", name: "Mangan", molarMass: 54.938 },
  { symbol: "Mo", name: "Molibdenum", molarMass: 95.95 },
  { symbol: "Mt", name: "Meitnerium", molarMass: 278 },
  { symbol: "N", name: "Nitrogen", molarMass: 14.007 },
  { symbol: "Na", name: "Natrium", molarMass: 22.99 },
  { symbol: "Nb", name: "Niobium", molarMass: 92.906 },
  { symbol: "Nd", name: "Neodimium", molarMass: 144.242 },
  { symbol: "Ne", name: "Neon", molarMass: 20.18 },
  { symbol: "Np", name: "Neptunium", molarMass: 237 },
  { symbol: "Os", name: "Osmium", molarMass: 190.23 },
  { symbol: "O", name: "Oksigen", molarMass: 15.999 },
  { symbol: "Pd", name: "Palladium", molarMass: 106.42 },
  { symbol: "P", name: "Fosfor", molarMass: 30.974 },
  { symbol: "Pt", name: "Platinum", molarMass: 195.084 },
  { symbol: "Pu", name: "Plutonium", molarMass: 244 },
  { symbol: "Pa", name: "Protaktinium", molarMass: 231.035 },
  { symbol: "Rb", name: "Rubidium", molarMass: 85.4678 },
  { symbol: "Re", name: "Renium", molarMass: 186.207 },
  { symbol: "Rh", name: "Rodium", molarMass: 102.905 },
  { symbol: "Ru", name: "Rutenium", molarMass: 101.07 },
  { symbol: "S", name: "Sulfur", molarMass: 32.06 },
  { symbol: "Sb", name: "Antimon", molarMass: 121.76 },
  { symbol: "Sc", name: "Skandium", molarMass: 44.955 },
  { symbol: "Se", name: "Selenium", molarMass: 78.971 },
  { symbol: "Si", name: "Silikon", molarMass: 28.085 },
  { symbol: "Sm", name: "Samarium", molarMass: 150.36 },
  { symbol: "Sn", name: "Timah", molarMass: 118.71 },
  { symbol: "Sr", name: "Stronsium", molarMass: 87.62 },
  { symbol: "Ta", name: "Tantalum", molarMass: 180.947 },
  { symbol: "Tb", name: "Terbium", molarMass: 158.925 },
  { symbol: "Tc", name: "Teknesium", molarMass: 98 },
  { symbol: "Te", name: "Telurium", molarMass: 127.6 },
  { symbol: "Th", name: "Torium", molarMass: 232.038 },
  { symbol: "Ti", name: "Titanium", molarMass: 47.867 },
  { symbol: "Tl", name: "Talium", molarMass: 204.38 },
  { symbol: "Tm", name: "Tulium", molarMass: 168.934 },
  { symbol: "U", name: "Uranium", molarMass: 238.028 },
  { symbol: "V", name: "Vanadium", molarMass: 50.941 },
  { symbol: "W", name: "Tungsten", molarMass: 183.84 },
  { symbol: "Xe", name: "Xenon", molarMass: 131.293 },
  { symbol: "Y", name: "Itrium", molarMass: 88.906 },
  { symbol: "Yb", name: "Iterbium", molarMass: 173.04 },
  { symbol: "Zn", name: "Seng", molarMass: 65.38 },
  { symbol: "Zr", name: "Zirkonium", molarMass: 91.224 },
];
function Calculator() {
  const [compound, setCompound] = useState([{ element: "", atoms: 1 }]);
  const [molarMass, setMolarMass] = useState("");
  const [explanation, setExplanation] = useState("");
  const [error, setError] = useState("");
  const handleAddElement = () => {
    setCompound([...compound, { element: "", atoms: 1 }]);
  };
  const handleElementChange = (index, value) => {
    const newCompound = [...compound];
    newCompound[index].element = value;
    setCompound(newCompound);
  };
  const handleAtomChange = (index, value) => {
    const newCompound = [...compound];
    newCompound[index].atoms = value;
    setCompound(newCompound);
  };
  const handleCalculate = () => {
    let totalMolarMass = 0;
    let explanationSteps = "";
    for (const { element, atoms } of compound) {
      if (!element) {
        setError("Harap masukkan semua elemen dan jumlah atom dengan benar");
        setMolarMass("");
        setExplanation("");
        return;
      }
      const elementData = elements.find((e) => e.symbol === element);
      if (!elementData) {
        setError("Elemen tidak valid. Silakan pilih elemen yang benar.");
        setMolarMass("");
        setExplanation("");
        return;
      }
      const elementMolarMass = elementData.molarMass * atoms;
      totalMolarMass += elementMolarMass;
      explanationSteps += `${atoms} × ${elementData.molarMass
        } (massa molar ${elementData.name}) = ${elementMolarMass.toFixed(
          2
        )} g/mol\n`;
    }
    setMolarMass(totalMolarMass.toFixed(2));
    setExplanation(explanationSteps);
    setError("");
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Massa molar adalah massa satu mol unsur atau senyawa kimia. Untuk menghitung massa molar senyawa tertentu, kita harus menjumlahkan massa molar semua atom yang ada dalam senyawa tersebut. Massa molar suatu unsur dapat ditemukan dalam tabel periodik, dan satuannya adalah g/mol. Misalnya, untuk menghitung massa molar air (H₂O):
                </p>
                <ul>
                  <li>Massa molar hidrogen = 1,008 g/mol</li>
                  <li>Massa molar oksigen = 16,00 g/mol</li>
                  <li>
                    Massa molar air = (2 × 1,008) + 16,00 = 18,016 g/mol
                  </li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <hr />
                <div >
                  {compound.map((item, index) => (
                    <div
                      key={index}
                      className="form-group d-flex align-items-center"
                    >
                      <b>
                        <label className="form-label ms-2">
                          Elemen {index + 1}
                        </label>
                      </b>
                      <select
                        value={item.element}
                        onChange={(e) =>
                          handleElementChange(index, e.target.value)
                        }
                        className="form-control"
                        style={{ width: "150px", marginRight: "10px" }}
                      >
                        <option value="">Pilih Elemen</option>
                        {elements.map((el) => (
                          <option key={el.symbol} value={el.symbol}>
                            {el.name} ({el.symbol})
                          </option>
                        ))}
                      </select>
                      <input
                        type="number"
                        min="1"
                        placeholder="Jumlah atom"
                        value={item.atoms}
                        onChange={(e) =>
                          handleAtomChange(index, parseInt(e.target.value))
                        }
                        className="form-control"
                        style={{ width: "90%" }}
                      />
                    </div>
                  ))}
                  <br />
                  <button
                    className="btn btn-success"
                    onClick={handleAddElement}
                  >
                    Tambah Elemen Lain
                  </button>
                  <br/>                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={handleCalculate}
                  >
                    Hitung
                  </button>
                </div>
                <br />
                <div>
                  { error !== "" ? (
                    <p className="p-3 mb-2 bg-warning text-white">
                      Error: {error}
                    </p>
                  ) : (
                    <>
                      { molarMass !== "" && (
                        <>
                          <p className="p-3 mb-2 bg-success text-white">
                            Massa Molar (g/mol): {molarMass}
                          </p>
                          {explanation !== "" && (
                            <p className="p-3 mb-2 bg-info text-black">
                              Langkah Perhitungan: <br />
                              {explanation.split("\n").map((line, index) => (
                                <React.Fragment key={index}>
                                  {line}
                                  <br />
                                </React.Fragment>
                              ))}
                            </p>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
            <hr /><div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList />
          <br />
        </div>
      </div>
      {" "}
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Apa itu Massa Molar?</h3>
              </div>
              <div className="info-section-body">
                <p>
                  Massa molar adalah massa satu mol suatu zat. Mol adalah satuan pengukuran jumlah zat, dan setara dengan 6,022 × 10^23 partikel (atom, molekul, ion).
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Mengapa Massa Molar Penting?</h3>
              </div>
              <div className="info-section-body">
                <p>
                  Massa molar digunakan dalam banyak perhitungan kimia, seperti:
                </p>
                <ul>
                  <li>Konversi antara massa dan jumlah mol</li>
                  <li>Menentukan rumus kimia senyawa</li>
                  <li>Menghitung konsentrasi</li>
                  <li>Menghitung perbandingan berat dalam reaksi kimia</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>Satuan Massa Molar</h3>
              </div>
              <div className="info-section-body">
                <p>Satuan massa molar adalah gram/mol (g/mol).</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Massa Molar dan Rumus Empiris
                </h3>
              </div>
              <div className="info-section-body">
                <p>
                  Massa molar dapat digunakan untuk menentukan rumus empiris suatu senyawa. Rumus empiris adalah perbandingan bilangan bulat paling sederhana dari jumlah atom unsur-unsur dalam senyawa.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Massa Molar dalam Persamaan Kimia
                </h3>
              </div>
              <div className="info-section-body">
                <p>
                  Massa molar digunakan untuk mengkonversi antara massa zat dan jumlah mol dalam persamaan kimia. Ini memungkinkan perhitungan kuantitas yang dihasilkan dari reaksi kimia.
                </p>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default Calculator;